import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService implements OnDestroy {
  private visibilityListener = () => { if (document.visibilityState === "visible") this.claimSoundOwnership(); };
  ngOnDestroy(): void { clearInterval(this.heartbeatInterval); document.removeEventListener("visibilitychange", this.visibilityListener); try { localStorage.removeItem(`heartbeat_${this.windowId}`); if (this.isNotificationOwner()) localStorage.removeItem("activeChatSoundTab"); } catch {} }

  /**
   * ID único generado para identificar esta pestaña del navegador.
   */
  private readonly windowId = Math.random().toString(36).substring(2, 9);

  /**
   * Referencia al intervalo del heartbeat.
   */
  private heartbeatInterval: any;

  /**
   * Mapa de claves de sonido a sus rutas respectivas.
   */
  private sounds: { [key: string]: string } = {
    chat: 'assets/audios/nota.mp3',
    nota: 'assets/audios/chat.mp3',
    newChat: 'assets/audios/nuevo-chat.mp3',
    newOwnMessageChat: 'assets/audios/own-message-chat.mp3',
    newMessageChat: 'assets/audios/new-message.mp3',
  };

  private sessionActive = false;
  constructor() {}
  startNotificationSession(): void { if (this.sessionActive) return; this.sessionActive = true; this.startHeartbeat(); document.addEventListener('visibilitychange', this.visibilityListener); }
  stopNotificationSession(): void { this.sessionActive = false; this.ngOnDestroy(); }

  /**
   * Reproduce un sonido solo si esta pestaña es la activa.
   * @param soundKey Clave que identifica el sonido a reproducir.
   */
  isNotificationOwner(): boolean { try { return localStorage.getItem('activeChatSoundTab') === this.windowId; } catch { return document.visibilityState === 'visible'; } }

  play(soundKey: string): void {
    const isActive = this.isNotificationOwner();
    if (!isActive) {
      return;
    }

    const soundPath = this.sounds[soundKey];
    if (soundPath) {
      const audio = new Audio(soundPath);
      audio.play().catch((err) => {
        console.warn(`No se pudo reproducir el sonido "${soundKey}":`, err);
      });
    } else {
      console.warn(`Sonido "${soundKey}" no encontrado.`);
    }
  }

  /**
   * Asigna esta pestaña como la responsable de emitir sonidos.
   */
  private claimSoundOwnership(): void {
    try { localStorage.setItem('activeChatSoundTab', this.windowId); } catch {}
  }

  /**
   * Inicia el latido (heartbeat) que indica que esta pestaña sigue activa.
   */
  private startHeartbeat(): void {
    this.claimSoundOwnership();

    this.heartbeatInterval = setInterval(() => {
      const timestamp = Date.now();
      try { localStorage.setItem(`heartbeat_${this.windowId}`, timestamp.toString()); } catch {}

      // Revisa si la pestaña asignada sigue viva, si no, se toma el control
      this.cleanupHeartbeats();
    }, 2000); // cada 2 segundos
  }

  /**
   * Valida si la pestaña actual aún debe tener el control del sonido.
   * Si la pestaña activa no ha enviado latido en los últimos 5 segundos,
   * esta pestaña asume el control.
   */
  private cleanupHeartbeats(): void {
    let activeId: string | null; let lastHeartbeat: number;
    try { activeId = localStorage.getItem('activeChatSoundTab'); lastHeartbeat = parseInt(localStorage.getItem(`heartbeat_${activeId}`) || '0', 10); } catch { return; }
    const now = Date.now();
    const isStale = now - lastHeartbeat > 5000;

    if (isStale) {
      this.claimSoundOwnership();
    }
  }
}
